import { useIntl } from 'react-intl'
import { deploymentApi } from '@/api/deploymentApi'
import {
  FilterSelectAsync,
  FilterSelectAsyncProps
} from '@/components/ui-shared/Tables/FilterSelect/FilterSelectAsync'
import { deploymentQueryKeys } from '@/queries/deploymentQueries'
import { DeploymentDeviceFilterOption } from '@/types/deployment'

type DeviceFilterProps = Pick<
  FilterSelectAsyncProps<
    DeploymentDeviceFilterOption,
    DeploymentDeviceFilterOption[]
  >,
  'value' | 'onChange'
>

export const DeviceFilter = ({ value, onChange }: DeviceFilterProps) => {
  const intl = useIntl()

  return (
    <FilterSelectAsync<
      DeploymentDeviceFilterOption,
      DeploymentDeviceFilterOption[]
    >
      width={220}
      value={value}
      queryFn={() => deploymentApi.getDeploymentDeviceFilterOptions()}
      queryKey={deploymentQueryKeys.deviceFilterOptions()}
      getOptionValue={(device) => device.id}
      getOptionLabel={(device) => device.name}
      placeholder={intl.formatMessage({
        id: 'deployments.list.filter.device.placeholder'
      })}
      onChange={onChange}
    />
  )
}
